// extracted by mini-css-extract-plugin
export default {"container":"gZ-z","title":"hZ-z","link":"iZ-z"};